<template>
    <div class="not-found">
        <img src="https://img1.baidu.com/it/u=2662682505,1738248369&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500"
            alt="404">
        <router-link to="/article" class="back-btn">return</router-link>
    </div>
</template>
<script>
export default {
    name: 'NotFound',
    data() {
        return {
            msg: '404 Not Found'
        }
    }
}
</script>
<style scoped>
.not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
    background-color: #f5f5f5;
}

img {
    width: 20rem;
    height: 20rem;
    margin-bottom: 2rem;
}

.back-btn {
    padding: 12px 30px;
    font-size: 1.1rem;
    background-color: #1865ad;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.back-btn:hover {
    background-color: #0e6cb9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
